import analytics from '@utils/analytics';
import stoneAnalytics from '@stone/utils/analytics';
import einsteinutils from '@utils/einsteinutils';
import { pageSize } from '@utils/search';
import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects';
import api from '../../utils/api';
import { ListingActionTypes } from './common.types';
import { addApiError, clearApiErrors } from './errors.slice';
import { addRedirect } from './redirect.slice';
import loadingSlice from './loading.slice';
import searchSlice from './search.slice';
/**
 * @desc Business logic of effect.
 */
const LISTING = 'LISTING';
const DEFAULT_SORTING = 'RELEVANCE';
const PAGE_SIZE = 20;
let abortController;
function* handleListingFetch(action) {
    var _a, _b;
    try {
        const { apiErrors } = yield select((state) => state.errors);
        if (apiErrors.length > 0) {
            yield put(clearApiErrors());
        }
        const { selectedFilters, productSort, selectedSort, cgid, progress, pageNumber, gridIndexes, crossCategoryLinksIndexes } = yield select((state) => state.search);
        const { start, resultsType, isShelf, tier } = action.payload;
        yield put(loadingSlice.actions.addLoadingItem(LISTING));
        const hasActiveFilters = selectedFilters.reduce((sum, filter) => sum + filter.values.length, 0) > 0;
        const hasActiveSorting = selectedSort && selectedSort !== productSort.defaultSortingRule && selectedSort !== DEFAULT_SORTING;
        const currentTier = hasActiveFilters || hasActiveSorting ? 'tier2' : tier;
        //da gestire multipli stati per listing contemporaneamente, al momento sovrascrive lo stesso
        if (abortController) {
            abortController.abort();
            abortController = null;
        }
        const searchResults = yield call(api.searchProducts, {
            selectedFilters,
            id: action.payload.cgid ? action.payload.cgid : cgid,
            slug: action.payload.slug,
            selectedSort,
            start,
            pageSize: pageSize(isShelf ? 8 : PAGE_SIZE, { tier: currentTier, start, resultsType, pageNumber, gridIndexes, crossCategoryLinksIndexes }),
            shelf: isShelf || undefined,
            abortController: (abortController = new AbortController()),
        });
        if ('redirectOnError' in searchResults) {
            // The user lands on a  PDP that is not available (depending on his Customer Groups)
            yield put(addRedirect({
                error: searchResults.error,
                redirectOnError: searchResults.redirectOnError,
            }));
        }
        else {
            if ((_a = searchResults === null || searchResults === void 0 ? void 0 : searchResults.category) === null || _a === void 0 ? void 0 : _a.id) {
                einsteinutils.categoryContext((_b = searchResults === null || searchResults === void 0 ? void 0 : searchResults.category) === null || _b === void 0 ? void 0 : _b.id);
            }
            switch (action.payload.resultsType) {
                case 'PAGE':
                    yield put(searchSlice.actions.updateResults({
                        target: 'LISTING',
                        data: searchResults,
                        resultsType: resultsType,
                        infiniteScroll: action.payload.infinitescroll,
                    }));
                    // const pageLoad: SearchState = yield select((state: ApplicationState) => state.search);
                    if (window.brandId === 'MO')
                        analytics.productImpressions(searchResults.products, progress, true, isShelf, searchResults === null || searchResults === void 0 ? void 0 : searchResults.category);
                    if (window.brandId === 'ST')
                        stoneAnalytics.proxyProductImpressions(searchResults, progress, true, isShelf);
                    break;
                case 'INIT':
                    yield put(searchSlice.actions.initResults({
                        isShelf,
                        cgid: action.payload.cgid,
                        data: searchResults,
                        resultsType: resultsType,
                        start: action.payload.start,
                        infiniteScroll: action.payload.infinitescroll,
                    }));
                    // const firstLoad: SearchState = yield select((state: ApplicationState) => state.search);
                    // if (searchResults?.category?.pageType != 'shelf') analytics.productImpressions(searchResults.products, progress, false, isShelf);
                    if (window.brandId === 'MO')
                        analytics.productImpressions(searchResults.products, progress, false, isShelf, searchResults === null || searchResults === void 0 ? void 0 : searchResults.category);
                    if (window.brandId === 'ST')
                        stoneAnalytics.proxyProductImpressions(searchResults, searchResults.pageNumber !== 0 ? progress : 0, false, isShelf);
                    //  yield put(searchSlice.actions.initFilters(action.payload));
                    break;
            }
        }
    }
    catch (err) {
        yield put(addApiError({
            code: 'PAGE',
            metadata: { location: 'handleListingFetch' },
        }));
    }
    yield put(loadingSlice.actions.clearLoadingItems());
}
function* handleListingRefinement(action) {
    try {
        const { apiErrors } = yield select((state) => state.errors);
        if (apiErrors.length > 0) {
            yield put(clearApiErrors());
        }
        switch (action.payload.filterAction) {
            case 'ADD':
                yield put(searchSlice.actions.addFilters(action.payload));
                break;
            case 'SORT':
                yield put(searchSlice.actions.updateSort(action.payload.selectedSort));
                break;
            case 'RESET':
                yield put(searchSlice.actions.resetFilter(action.payload));
                break;
            case 'REPLACE':
                yield put(searchSlice.actions.replaceFilters(action.payload));
                break;
        }
    }
    catch (err) {
        yield put(addApiError({
            code: 'UNKNOWN',
            metadata: { location: 'handleListingRefinement' },
        }));
    }
    // yield put(loadingSlice.actions.clearLoadingItems());
}
function* handleToggleLandingAnimation(action) {
    // console.info('ToggleLandingAnimation :', action.payload);
    yield put(searchSlice.actions.updateLandingAnimation(action.payload));
}
function* handleListingTrackBack() {
    const { progress, results, breadcrumbs } = yield select((state) => state.search);
    if (window.brandId === 'ST')
        stoneAnalytics.proxyProductImpressionsOnBack(results, breadcrumbs, progress);
}
function* handleGridIndexes(action) {
    yield put(searchSlice.actions.updateGridIndexes(action.payload));
}
function* handleCrossCategoryLinksIndexes(action) {
    yield put(searchSlice.actions.updateCrossCategoryLinksIndexes(action.payload));
}
/**
 * @desc Watches every specified action and runs effect method and passes action args to it
 */
function* watchFetchRequest() {
    yield takeEvery(ListingActionTypes.TOGGLE_LANDING_ANIMATION, handleToggleLandingAnimation);
    yield takeEvery(ListingActionTypes.FETCH_LISTING, handleListingFetch);
    yield takeEvery(ListingActionTypes.UPDATE_LISTING_REFINEMENT, handleListingRefinement);
    yield takeEvery(ListingActionTypes.TRACKBACK_LISTING, handleListingTrackBack);
    yield takeEvery(ListingActionTypes.UPDATE_GRID_INDEXES, handleGridIndexes);
    yield takeEvery(ListingActionTypes.UPDATE_CROSS_CATEGORY_LINKS_INDEXES, handleCrossCategoryLinksIndexes);
}
/**
 * @desc saga init, forks in effects, other sagas
 */
export default function* listingSaga() {
    yield all([fork(watchFetchRequest)]);
}
